module.exports = __webpack_public_path__ + "static/media/ic_contract_information_deactivate.4be61d8b.svg";